export default {
	setStorage(key, token) {
		window.localStorage.setItem(key, token)
	},

	getStorage(key) {
		return window.localStorage.getItem(key)
	},

	removeFromStorage(key) {
		return window.localStorage.removeItem(key)
	}
}
